import React from "react";
import PropTypes from "prop-types";
import { Comment } from "semantic-ui-react";
import Link from "next/link";
import { ButtonItem } from "../../components";
import { styles } from "./element.js";
import Moment from "react-moment";
import ShowMoreText from "react-show-more-text";
// import 'moment-timezone';

const NewEcomment = ({
  answerId,
  userid,
  name,
  date,
  text,
  source,
  helpcontent,
  helpStatus,
  rplylike,
  onLike,
  totdata,
  key1,
  queid,
  rlike_queid_qc_index,
  totstate,
  usertype,
}) => {
  return (
    <Comment.Group style={{ marginTop: 0 }} key={key1}>
      <Comment>
        {userid ? (
          <a
            href={`/ProfileRealtor/?id=${userid}`}
            target="_blank"
            style={{ color: "#1b57a5  !important" }}
          >
            <Comment.Avatar as="a" src={source} />
          </a>
        ) : (
          <Comment.Avatar as="a" src={source} />
        )}
        <Comment.Content style={{ marginLeft: "3.5em" }}>
          {userid ? (
            <a
              href={`/ProfileRealtor/?id=${userid}`}
              target="_blank"
              style={{ color: "#1b57a5 !important" }}
            >
              <Comment.Author as="a">
                <span className="realtor_name">{name}</span>
              </Comment.Author>
            </a>
          ) : (
            <Comment.Author as="a">{name}</Comment.Author>
          )}{" "}
          {/* <span className="user_que_type">({usertype})</span> */}
          <Comment.Metadata>
            <span>
              <Moment fromNow>{date}</Moment>
            </span>
          </Comment.Metadata>
          {userid && (
            <Comment.Text style={{ margin: 0 }}>
              <Comment.Metadata style={{ margin: 0 }}>
                Real Estate Agent
              </Comment.Metadata>
            </Comment.Text>
          )}
          <ShowMoreText
            /* Default options */
            lines={3}
            more="show more"
            less="show less"
            className="content-css"
            anchorClass="my-anchor-css-class"
            //onClick={this.executeOnClick}
            expanded={false}
            //width={280}
          >
            <Comment.Text>{text}</Comment.Text>
          </ShowMoreText>
          <div className="help_btn_container">
            {/*{totstate['rlike_'+queid+'_qc_'+key1] === true && rplylike[key1] || helpStatus === 1 ?*/}
            {totdata.helpedUserId === "1" ? (
              <ButtonItem
                name="rply"
                onClick={(e) =>
                  onLike(
                    key1,
                    e,
                    totdata,
                    queid,
                    rlike_queid_qc_index,
                    answerId,
                  )
                }
                basic
                icon="thumbs up"
                content="Helpful"
              />
            ) : (
              <ButtonItem
                name="rply"
                onClick={(e) =>
                  onLike(
                    key1,
                    e,
                    totdata,
                    queid,
                    rlike_queid_qc_index,
                    answerId,
                  )
                }
                basic
                icon="thumbs up outline"
                content="Helpful"
              />
            )}
            <span style={styles.helpcontent}>
              {helpcontent > 0 ? helpcontent : ""}
            </span>
          </div>
        </Comment.Content>
      </Comment>
    </Comment.Group>
  );
};

NewEcomment.propTypes = {
  source: PropTypes.string,
  name: PropTypes.string,
  date: PropTypes.string,
  text: PropTypes.string,
};

export default NewEcomment;
